import gql from 'graphql-tag';

export default gql`
  mutation notificationUnregister($input: NotificationUnregisterInput!) {
    notificationUnregister(input: $input) {
      success
    }
  }
`;
